import type { SpringError } from "@p-ban/common/src/core/api/createHttpClient"

import httpClient from "../../../api/httpClient"
import type SignUpFormValues from "../types/SignUpFormValues"
import type { SignUpApplyRequest } from "../types/SignUpEstimate"
import SIGNUP_END_POINT from "./SIGNUP_END_POINT"

type UserCreateParams = SignUpFormValues & {
  viaReferralLink: boolean
}

type SignUpApplyResponse = { acceptedEmail: string; periodOfValidity: number }

const signUpApi = {
  async apply(payload: SignUpApplyRequest) {
    const { email, coupon, url, estimateDraft } = payload
    const formData = new FormData()
    const properties = {
      email,
      ...(coupon && { coupon }),
      ...(url && { url }),
      ...(estimateDraft && {
        estimateDraft: {
          ...estimateDraft,
          manufactureCourse: estimateDraft.manufactureCourse.value,
        },
      }),
    }
    const propertiesBlob = new Blob([JSON.stringify(properties)], { type: "application/json" })
    formData.append("properties", propertiesBlob)

    return httpClient.post<SignUpApplyResponse, SpringError<typeof payload>>(SIGNUP_END_POINT.APPLY, formData)
  },
  async check(validateKey: string) {
    return httpClient.get<{ email: string }>(SIGNUP_END_POINT.CHECK, { queryParams: { validateKey } })
  },
  async create(data: UserCreateParams) {
    const payload = {
      ...data,
      personalOrCorporate: data.personalOrCorporate?.value,
    }

    return httpClient.post<{ userId: string; email: string; redirectUrl: string }, SpringError<typeof payload>>(
      SIGNUP_END_POINT.CREATE,
      payload,
    )
  },
} as const

export default signUpApi
